// extracted by mini-css-extract-plugin
module.exports = {"totalPremiumContainer":"PolicyVehiclesDriversInfo_totalPremiumContainer__3geC2","policyDriverContainer":"PolicyVehiclesDriversInfo_policyDriverContainer__2LrNt"};